/* istanbul ignore file */
import { oneOf as codecOneOf } from 'purify-ts/Codec';
import { DeletedCommentReply } from './DeletedCommentReply';
import { NonDeletedCommentReply } from './NonDeletedCommentReply';
const CommentReplyParser = /* #__PURE__ */ /* #__PURE__ */ codecOneOf([
    NonDeletedCommentReply,
    DeletedCommentReply,
]);
export const CommentReply = CommentReplyParser;
